
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

import FileUpload from '@/components/file-upload';
import DivSpan from '@/components/DivSpan';

export default {
name: 'redundancy-allocation',
components: { Grid, GridItem, FileUpload, DivSpan, },
props: ['dataId'],
data() {
return {
index: 1,
baseDto: {
redundantRequisitionDt: [],
},
actNodeId: '',
transferStatusList: [
{ label: '不申请', value: '0' },
{ label: '调拨', value: '1' },
{ label: '不调拨', value: '2' },
{ label: '无法调拨', value: '3' }
],
noReasonList: [
{ label: '成品交期紧张', value: '1' },
{ label: '不够起订量凑单', value: '2' },
{ label: '存在质量问题', value: '3' },
{ label: '补单', value: '4' },
{ label: '包装桶零担调拨易刮花表面', value: '5' },
{ label: '其他问题', value: '6' },
],
noReasonPlaceHolderList: [
'请补充交期紧张的充分说明',
'请补充最小起订量说明和拼单记录',
'请补充冗余品存在质量问题的说明',
'请补充实际要货截图及时间',
'',
''
],
isTableDisabled: false,
transferStatus_isDisabled: false,
};
},
methods: {
itemTab(index) {
this.index = index;
if (index !== 'flow') {
this.$emit('changeFlowInfo', false);
} else {
this.$emit('changeFlowInfo', true);
}
},
getBaseDto() {
this.$loadingShow();
this.$get('api/redundantRequisition/' + this.dataId).then((data = {}) => {
this.actNodeId = (((data.requestBase || {}).workflowNodeBase || {}) || {}).actNodeId;

this.isNewAgreeChange();
if (data) {
data.redundantRequisitionDt = data.redundantRequisitionDt.map(item => {
if (item.opinion == '0') {

item.opinion = '';
}
return item;
});
this.baseDto = data;
}
this.$loadingHide();
}).catch(() => {
this.$loadingHide();
});
},

changeClaim(claimDtDto) {
if (claimDtDto.show) {
this.$set(claimDtDto, 'show', false);
return;
}
this.$set(claimDtDto, 'show', true);
},

valid() {
console.log('valid', this.baseDto, this.baseDto.opinion);

let boo = true;
const list = this.baseDto.redundantRequisitionDt || [];
if (this.isFlowNode2()) {
for (let item of list) {
const redundantNumber = item.redundantNumber;
if (!redundantNumber && redundantNumber !== 0) {
this.$message.warning('请填写可调拨数量！');
return false;
}
if (item.opinion != '1' && item.opinion != '2') {
this.$message.warning('请选择是否同意调拨！');
return false;
}
}
}

if (this.isFlowNode4()) {

const flag = list.some(item => item.transferNumber > item.redundantNumber)
if (this.baseDto.opinion == '1') {
let index = 0;
for (let item of list) {
index = index + 1;
const transferNumber = Number(item.transferNumber || 0);
const redundantNumber = Number(item.redundantNumber || 0);
if (transferNumber == 0 && item.opinion == '1' && item.selected) {
this.$message.warning('请填写实际调拨数量！');
return false;
} else if (transferNumber > redundantNumber && item.opinion == '1' && item.selected) {
this.$message.warning(`第${index}行实际调拨数量不能大于可调拨数量！`);
return false;
}
}
}
if (flag) {
boo = false

this.$message.warning('实际调拨数量不能大于可调拨数量！');
}
if (!boo) {
return boo;
}
}

if (this.baseDto.opinion == 2 || this.baseDto.opinion == 0) {
if (!this.baseDto.reason || !this.baseDto.noReason) {
boo = false

this.$message.warning('请填写原因或详细说明！');
}
if (!this.baseDto.docAttach) {
boo = false
this.$message.warning('请上传附件！');
}
const noReason = this.baseDto.noReason || '';
if (!noReason.trim()) {
boo = false

this.$message.warning('请选择不调原因！');
}
if (!boo) {
return boo;
}
}

if (this.isFlowNode1()) {

if (this.baseDto.opinion == 0) {
if (!this.baseDto.noReason) {
boo = false

this.$message.warning('请选择不调原因！');
}
if (!this.baseDto.reason) {
boo = false

this.$message.warning('请填写原因！');
}
if (!this.baseDto.docAttach) {
boo = false
this.$message.warning('请上传附件！');
}
}
if (this.baseDto.opinion == null) {
boo = false

this.$message.warning('请选择采购是否调拨！');
}

}

if (this.isFlowNode3()) {
if (this.baseDto.opinion == '1') {
for (let item of list) {
if (!item.transferPrice && item.transferPrice !== 0 && item.opinion == '1') {
this.$message.warning('请填写调拨单价！');
return false;
}
}
}
}

const isSelectedProduct = this.baseDto.redundantRequisitionDt.some(item => item.selected)
if (!isSelectedProduct && this.isFlowNode4() && this.baseDto.opinion == '1') {
boo = false
this.$message.warning('请勾选数据！')
}
return boo;

},

formData() {
if (this.isFlowNode4()) {
this.baseDto.redundantRequisitionDt = this.redundantRequisitionInfoData.redundantRequisitionDt.filter(item => item.selected == true)
}
return this.baseDto;
},
onSelectAll(event, type, rowData) {
if (type == 'row') {
rowData.selected = event.target.checked
}

if (type == 'all') {
this.baseDto.redundantRequisitionDt = this.baseDto.redundantRequisitionDt.map(item => {
if (item.opinion == '1') {
item.selected = event.target.checked
} else {
item.selected = false;
}
return item;
})
}
},
transferStatusChange(event) {
this.isTableDisabled = event == 2;
if (event == '0') {
this.baseDto.isAgreedTransferPurchases = null;
}
if (event == '1') {
this.baseDto.reason = '';
this.baseDto.noReason = null;
this.baseDto.noReasonPlaceHolder = '';
this.baseDto.docAttach = null;
}
else {
this.baseDto.redundantRequisitionDt.map(item => item.transferNumber = 0)
}
},
isNewAgreeChange() {
setTimeout(() => {
const redundantRequisitionDt = this.baseDto.redundantRequisitionDt || [];

const allYes = redundantRequisitionDt.filter(item => item.opinion === '1')
if (allYes && allYes.length > 0) {
this.baseDto.isAgreedTransferPurchases = '同意'
}

const allYes2 = redundantRequisitionDt.filter(item => item.opinion === '2');
if (allYes2 && allYes2.length === redundantRequisitionDt.length) {
this.baseDto.isAgreedTransferPurchases = '拒绝';
}
if (this.baseDto.opinion == '0') {
this.baseDto.isAgreedTransferPurchases = null;
}
if (this.actNodeId == 'P1') {
this.transferStatusList = [
{ label: '不申请', value: '0' },
{ label: '调拨', value: '1' },
]
}

if (this.actNodeId == 'P3') {
this.transferStatusList = [
{ label: '调拨', value: '1' },
{ label: '不调拨', value: '2' },
]
}
if (this.isFlowNode4() && allYes2 && allYes2.length === redundantRequisitionDt.length) {
this.transferStatusList.push({ label: '无法调拨', value: '3' });
this.baseDto.opinion = '3';
this.transferStatus_isDisabled = true;
}
}, 1000);
},
isAgreeChange() {
setTimeout(() => {

const allYes = this.baseDto.redundantRequisitionDt.some(item => item.opinion === '1')
if (allYes) {
this.baseDto.isAgreedTransferPurchases = '同意'
}
const allYes2 = this.baseDto.redundantRequisitionDt.some(item => item.opinion === '2')
if (allYes2) {
this.baseDto.isAgreedTransferPurchases = '拒绝'
}
if (this.baseDto.opinion == '0') {
this.baseDto.isAgreedTransferPurchases = null;
}
}, 1000);
},
noReasonChange(event) {
this.baseDto.noReasonPlaceHolder = this.noReasonPlaceHolderList[event - 1] || ''
},
isFlowNode1() {
return this.actNodeId == 'P1'
},

isFlowNode2() {
return this.actNodeId == 'P2'
},


isNotFlowNode2OrSend() {
const actNodeId = this.actNodeId;
return actNodeId != 'P2' && actNodeId != 'send';
},


isFlowNode3() {
return this.actNodeId == 'P4'
},
isFlowNode4() {
return this.actNodeId == 'P3'
}
},
mounted() {
if (this.dataId) {
this.getBaseDto();
}
},
watch: {
dataId() {
if (this.dataId) {
this.getBaseDto()
}
}
}
};



// WEBPACK FOOTER //
// ./src/page/purchase-requisition/redundancy-allocation.vue